export const FEATURE_FLAG = {
    EINVOICING_RECEIVING: 'einvoicing_receiving',
    EINVOICING_RECEIVING_FRANCE: 'einvoicing_receiving_france',
    PEPPOL_ACCESS: 'peppol_access',
    AI_ASSISTANT: 'ai_assistant',
    // Gates the Messages & Visibility sidebar entries so the SECL work can ship to develop/prod
    // dark. Off → both modules are hidden from the nav (see useModules appsModules).
    MESSAGES_VISIBILITY: 'messages_visibility',
    // Multivariate experiment: inbound signup flow mode. Variants: 'modal' | 'fullpage' (spec §4.4).
    INBOUND_SIGNUP_VARIANT: 'inbound-signup-flow',
} as const;

export type FeatureFlag = Enum<typeof FEATURE_FLAG>;
